import * as types from '../constants/actionsTypes';

const initialState = {
	authToken: localStorage.getItem('AuthToken') || null,
	initData: null,
	error: null,
	loading: false
}

export default function (state = initialState, action) {
	switch (action.type) {
		case types.LOGIN_SUCCESS:
			return {
				...state,
				authToken: action.authToken,
				error: null
			}

		case types.LOGIN_FAILURE:
			return {
				...state,
				error: action.error
			}

		case types.LOGOUT_SUCCESS:
			return {
				...state,
				error: null,
				authToken: null
			}

		case types.LOGIN_ERRORS_CLEAR:
			return {
				...state,
				error: null
			}

		case types.INIT_DATA_REQUEST:
			return {
				...state,
				loading: true
			}
		
		case types.INIT_DATA_SUCCESS:
			return {
				...state,
				initData: action.initData,
				loading: false
			}

		case types.INIT_DATA_FAILURE:
			return {
				...state,
				error: action.error,
				initData: null,
				loading: false,
				authToken: null
			}

		case types.LOAD_CULTURES_REQUEST:
			return {
				...state,
				loading: true
			}

		case types.LOAD_CULTURES_SUCCESS:
		case types.SAVE_CULTURE_SUCCESS:
		case types.DELETE_CULTURE_SUCCESS:
			return {
				...state,
				loading: false,
				initData: {
					...state.initData,
					cultures: action.list
				}
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./reducers/webInterface.js